/**
 * A site is Lite when its Learn instance says `Lite: true`, the flag the fleet config
 * variants in tenancy-config read. Anything else, a missing flag included, is a
 * Standard site, so a list read before the flag exists simply shows no Lite sites.
 */
export interface SiteTypeSource {
  Lite?: boolean;
}

export const SITE_TYPE_FILTERS = ['all', 'standard', 'lite'] as const;

export type SiteTypeFilter = (typeof SITE_TYPE_FILTERS)[number];

export const isLiteSite = (site: SiteTypeSource): boolean => site.Lite === true;

export const matchesSiteTypeFilter = (site: SiteTypeSource, filter: SiteTypeFilter): boolean => {
  switch (filter) {
    case 'lite':
      return isLiteSite(site);
    case 'standard':
      return !isLiteSite(site);
    default:
      return true;
  }
};
